export type Nullable<T> = T | null;
export type Optional<T> = Nullable<T> | undefined;

export function isPresent<T>(item: Optional<T>): item is T {
	return item !== null && item !== undefined;
}
